<template>
  <accordion-simple-item title="Magazin Typen"  :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <input v-model="magazinesSearch" type="text" placeholder="Suche..." class="p-2 w-full my-2">
      <button class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white" data-ui="create-magazine-type"
              @click="navigateTo(`/administration/${accordionIndex}/createMarketType` )">Neu erstellen
      </button>

      <div class=" overflow-y-auto "  data-ui="magazineType-list">
        <div v-if="filteredMagazinTypes !== null" v-for="magazine in  filteredMagazinTypes "
             :key="magazine.magazineTypeId">
          <div class="w-full p-1  flex my-2 hover:bg-trader-blue hover:text-white" :data-ui="'magazineType-'+ magazine.magazineTypeTitle"
               :class="{ 'bg-trader-blue text-white': idMagazineType == magazine.magazineTypeId, 'bg-trader-dark-gray': idMagazineType != magazine.magazineTypeId }"
               @click="navigateTo(`/administration/${accordionIndex}/marketType`, { marketTypeID: magazine.magazineTypeId })">
                  <span class="w-full cursor-pointer">
                  {{ magazine.magazineTypeTitle }}
                 </span>
          </div>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "SPurchaser",
  data() {
    return {
      magazinesSearch: '',
      magazineTypes: [],
      idMagazineType: 0,
    }
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  props: {

    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredMagazinTypes() {
      if (!this.magazineTypes) {
        // Hier könnten Sie ein leeres Array zurückgeben oder eine andere Logik implementieren
        return [];
      }
      return this.magazineTypes.filter(magazine =>
          magazine.magazineTypeTitle.toLowerCase().includes(this.magazinesSearch.toLowerCase()));
    },
  },
  methods: {
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },
    async getMagazineTypes() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getMagazineTypes {
              getMagazineTypes {
                magazineTypeId
                magazineType
                magazineTypeTitle
                supportMarkets

              }
            }
          `
        });

        this.magazineTypes = response.data.getMagazineTypes;

      } catch (error) {
        console.error("Fehler beim Abrufen der magazineTypes:", error);
      }
    },
  },
  mounted() {
    this.getMagazineTypes();
  },
  created() {
    this.idMagazineType =  this.$route.params.marketTypeId
  },
  watch: {
    '$route.params.marketTypeId': function (newId, oldId) {
      this.idMagazineType = newId;
      this.getMagazineTypes();
    },
  },
}
</script>